export default `float de(vec3 p){
    float r = 1.; 

    return fGDF(p, r, 13, 18);
  }

With Exponent

  float de(vec3 p){
    float r = 1.; 
    float e = 1.; 

    return fGDF(p, r, e, 13, 18);
  }`